'use strict';

let Shims = {
  // add console shim for ancient browsers
  consoleShim: function(){
    var f = function () {};
    if (!window.console) {
      window.console = {
        log: f, info: f, warn: f, debug: f, error: f
      };
    }
  },
  arrayPrototypes: function(){
    if (!('indexOf' in Array.prototype)) {
      Array.prototype.indexOf = function(find, i /*opt*/ ) {
        if (i === undefined) i = 0;
        if (i < 0) i += this.length;
        if (i < 0) i = 0;
        for (var n = this.length; i < n; i++)
          if (i in this && this[i] === find)
            return i;
        return -1;
      };
    }
    if (!('lastIndexOf' in Array.prototype)) {
      Array.prototype.lastIndexOf = function(find, i /*opt*/ ) {
        if (i === undefined) i = this.length - 1;
        if (i < 0) i += this.length;
        if (i > this.length - 1) i = this.length - 1;
        for (i++; i-- > 0;) /* i++ because from-argument is sadly inclusive */
          if (i in this && this[i] === find)
            return i;
        return -1;
      };
    }
    if (!Array.prototype.filter) {
      Array.prototype.filter = function(fun /*, thisArg*/ ) {
        if (this === void 0 || this === null) {
          throw new TypeError();
        }

        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== 'function') {
          throw new TypeError();
        }

        var res = [];
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for (var i = 0; i < len; i++) {
          if (i in t) {
            var val = t[i];

            // NOTE: Technically this should Object.defineProperty at
            //       the next index, as push can be affected by
            //       properties on Object.prototype and Array.prototype.
            //       But that method's new, and collisions should be
            //       rare, so use the more-compatible alternative.
            if (fun.call(thisArg, val, i, t)) {
              res.push(val);
            }
          }
        }

        return res;
      };
    }
  },
  elements: function() {
    // Fixes forEach in IE 11 NodeLists
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
          callback.call(thisArg, this[i], i, this);
        }
      };
    }

  },
  init: function(){
    this.consoleShim();
    this.arrayPrototypes();
    this.elements();
  }
};

export default Shims;
